module.exports = __webpack_public_path__ + "img/arrow.be5ddf77.jpeg";